export const ANALYTICS_GROUP = 'C0002';
export const ONE_TRUST_GROUPS_UPDATED_EVENT = 'OneTrustGroupsUpdated';

// OneTrust exposes ",C0001,C0002," on window but ["C0001","C0002"] in the event detail.
export const parseActiveGroups = (groups?: string | string[]): string[] =>
  Array.isArray(groups) ? groups : (groups || '').split(',').filter(Boolean);

export const hasAnalyticsConsent = (groups?: string | string[]): boolean =>
  parseActiveGroups(groups).includes(ANALYTICS_GROUP);

// Replays the consent already known (SDK loaded before React), then follows every change.
export const onAnalyticsConsentChange = (
  callback: (granted: boolean) => void,
): (() => void) => {
  if (window.OnetrustActiveGroups !== undefined) {
    callback(hasAnalyticsConsent(window.OnetrustActiveGroups));
  }
  const listener = (event: Event) =>
    callback(hasAnalyticsConsent((event as CustomEvent<string[]>).detail));
  window.addEventListener(ONE_TRUST_GROUPS_UPDATED_EVENT, listener);
  return () =>
    window.removeEventListener(ONE_TRUST_GROUPS_UPDATED_EVENT, listener);
};

// Google's documented opt-out flag, also honoured after gtag.js has loaded.
export const setGoogleAnalyticsDisabled = (
  measurementId: string,
  disabled: boolean,
): void => {
  (window as unknown as Record<string, boolean>)[
    `ga-disable-${measurementId}`
  ] = disabled;
};
